import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../services/api';
import { Load } from '../../components/Load';
import voltarIcon from '../../img/icon/Voltar.svg'
import AlertMessage from '../../components/Alert';
import eyeOpen from '../../img/icon/Olho.svg'
import eyeClose from '../../img/icon/Olho Fechado.svg'

const RedefinirSenha = () => {
    const { token } = useParams();
    const [novaSenha, setNovaSenha] = useState('');
    const [confirmarSenha, setConfirmarSenha] = useState('');
    const [disabled, setDisabled] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });
    const [showPassword, setShowPassword] = useState(false);
    const [novaSenhaStrength, setnovaSenhaStrength] = useState({ strength: '', color: '' });
    const [confirmarSenhaStrength, setconfirmarSenhaStrength] = useState({ strength: '', color: '' });
    const [senhaAlteradaComSucesso, setSenhaAlteradaComSucesso] = useState(false);
    const [mensagemSucesso, setMensagemSucesso] = useState('');
    const navigate = useNavigate();

    const handleNovaSenha = (e: { target: { value: any; }; }) => {
        const newPassword = e.target.value;
        setNovaSenha(newPassword);
        const strength = evaluatePasswordStrength(newPassword);
        setnovaSenhaStrength(strength);
    };

    const handleConfirmarSenha = (e: { target: { value: any; }; }) => {
        const newPassword = e.target.value;
        setConfirmarSenha(newPassword);
        const strength = evaluatePasswordStrength(newPassword);
        setconfirmarSenhaStrength(strength);
        setDisabled(false);
    };

    const evaluatePasswordStrength = (password: any) => {
        if (!password) return { strength: '', color: '' };
        const length = password.length;
        const hasNumbers = /\d/.test(password);
        const hasUpperCase = /[A-Z]/.test(password);
        const hasSpecialChars = /[!@#$%^&*(),.?":{}|<>]/.test(password);
        if (length > 8 && hasUpperCase && hasNumbers && hasSpecialChars) {
            return { strength: 'Muito forte', color: 'green' };
        } else if (length > 6 && hasUpperCase && hasNumbers) {
            return { strength: 'Forte', color: 'green' };
        } else if (length > 4 && (hasUpperCase || hasNumbers || hasSpecialChars)) {
            return { strength: 'Média', color: 'yellow' };
        } else if (length > 0) {
            return { strength: 'Fraca', color: 'red' };
        }
        return { strength: '', color: '' };
    };

    const handleSalvarNovaSenha = async () => {
        try {
            setIsLoading(true);
            if (novaSenha !== confirmarSenha) {
                return setAlert({ show: true, message: 'As senhas não conferem!', variant: 'danger' });
            }
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            };
            const response = await api.put('salvar-nova-senha', { novaSenha, token }, config);
            setIsLoading(false);
            if (response.status !== 200) throw new Error();
            setSenhaAlteradaComSucesso(true);
            const { mensagem } = response.data;
            setMensagemSucesso(mensagem);
        } catch (error) {
            setIsLoading(false);
            setAlert({ show: true, message: 'Erro ao salvar senha nova.', variant: 'danger' });
        }
    }

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <>
            <Load isLoading={isLoading} />
            <div className="rec-senha-content-login">
                {!senhaAlteradaComSucesso ? (
                    <>
                        <div className="iconTextContainer">
                            <a href="/">
                                <img className="icon" src={voltarIcon} alt="Back to the login page" />
                                <text className="back-text">Voltar</text>
                            </a>
                        </div>
                        <form className="rec-senha-inside-content" style={{ padding: '10px' }} onSubmit={(e) => { e.preventDefault(); handleSalvarNovaSenha() }}>
                            <label htmlFor="access" className="rec-senha-access-label">Redefinição de Senha</label>
                            <div className="rec-senha-form-group-auth">
                                <div className="pass-register password-input-container">
                                    <label htmlFor="password">DIGITE SUA NOVA SENHA</label>
                                    <div style={{ position: 'relative' }}>
                                        <input type={showPassword ? "text" : "password"}
                                            placeholder="Digite sua nova senha"
                                            style={{ maxWidth: '100%' }}
                                            onChange={handleNovaSenha}
                                        />
                                        <img
                                            className="olho"
                                            style={{ top: '65%' }}
                                            src={showPassword ? eyeClose : eyeOpen}
                                            onClick={togglePasswordVisibility}
                                            alt="Toggle password visibility"
                                        />
                                    </div>
                                    <span className={`badges ${novaSenhaStrength.color}`}>{novaSenhaStrength.strength}</span>
                                </div>
                            </div>
                            <div className="rec-senha-form-group-auth">
                                <div className="pass-register password-input-container">
                                    <label htmlFor="password">CONFIRME A SENHA</label>
                                    <div style={{ position: 'relative' }}>
                                        <input type={showPassword ? "text" : "password"}
                                            placeholder="Confirme sua senha"
                                            style={{ maxWidth: '100%' }}
                                            onChange={handleConfirmarSenha}
                                        />
                                        <img
                                            className="olho"
                                            style={{ top: '65%' }}
                                            src={showPassword ? eyeClose : eyeOpen}
                                            onClick={togglePasswordVisibility}
                                            alt="Toggle password visibility"
                                        />
                                    </div>

                                    <span className={`badges ${confirmarSenhaStrength.color}`}>{confirmarSenhaStrength.strength}</span>
                                </div>
                            </div>
                            <div className="rec-senha-btn-content">
                                <button className="rec-senha-btn-access"
                                    type="submit"
                                    disabled={disabled}>Salvar nova senha</button>
                            </div>
                        </form>
                    </>
                ) : (
                    <>
                        <div className="rec-senha-inside-content" style={{ padding: '10px' }}>
                            <label htmlFor="access" className="rec-senha-access-label" style={{ display: 'flex', justifyContent: 'center' }}>{mensagemSucesso}</label>
                            <div className="rec-senha-btn-content">
                                <button className="rec-senha-btn-access"
                                    onClick={() => navigate('/')}>Voltar para o login</button>
                            </div>
                        </div>
                    </>
                )}
            </div>
            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })}
            />
        </>
    );
}

export default RedefinirSenha;